module.exports = __webpack_public_path__ + "img/1 (68).cfc875e9.png";